<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const REASON = 'get_deletion_reason.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'reason',
		data: function () { 
			return {
				selected: '0',
				id: '0',
				options: []
			}
		},
		methods: {
			change () {
				EventBus.$emit(`deletion_reason`, this.selected)
			}
		},
		mounted () {
			fetch(DB + REASON, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.id
				}
				else {
					this.options = []
					this.selected = '0'
				}
			})
			.catch(err => console.log('6',err))
		}
	}
</script>


// WEBPACK FOOTER //
// deletionReason.vue?2d00b40e